/* unplugin-vue-components disabled */import script from "./workArrangement.vue?vue&type=script&setup=true&lang=ts"
export * from "./workArrangement.vue?vue&type=script&setup=true&lang=ts"

import "./workArrangement.vue?vue&type=style&index=0&id=891b34f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-891b34f6"]])

export default __exports__